import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/marketing/Reveal";

export default function SectorServices({ services = [], tag, title, subtitle }) {
  return (
    <section className="py-12 lg:py-16 bg-canvas">
      <Container>
        <Reveal>
        <SectionHeading tag={tag} title={title} subtitle={subtitle} />
        </Reveal>
        <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
          {services.map((s, i) => (
            <Reveal key={s.title} variant="card" delay={i * 0.08}>
            <div
              className="group glass-card p-8 lg:p-10 flex flex-col"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[rgba(139,92,246,0.1)] mb-6">
                <s.icon className="w-7 h-7 text-cobalt" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading text-xl font-[650] tracking-[-0.01em] text-bone mb-2.5">{s.title}</h3>
              <p className="text-[14px] leading-[1.6] text-steel mb-6">{s.desc}</p>
              {s.to.startsWith("#") ? (
                <a
                  href={s.to}
                  className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors mt-auto"
                >
                  {s.cta} <ArrowRight className="ml-1.5 w-4 h-4" />
                </a>
              ) : (
                <Link
                  to={s.to}
                  className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors mt-auto"
                >
                  {s.cta} <ArrowRight className="ml-1.5 w-4 h-4" />
                </Link>
              )}
            </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}